import {
  FormControl,
  FormErrorMessage,
  FormHelperText,
  Input,
  InputProps
} from '@chakra-ui/react'
import { FieldValues, useFormContext } from 'react-hook-form'
import { AttentionIcon } from '../Icons/AttentionIcon'
import { CommonFormLabel } from './CommonFormLabel'
import { FieldInputProps, getErrorMessage } from './FormTextInput'

type FormNumberInputProps<T extends FieldValues> = FieldInputProps<T, number> &
  InputProps

export const FormNumberInput = <T extends FieldValues = never>({
  name,
  isRequired,
  label,
  labelIndexNumber,
  helperText,
  helpTooltipText,
  showErrorText = true,
  errorMessage,
  w,
  ...inputProps
}: FormNumberInputProps<T>): ReturnType<React.VFC> => {
  const { register } = useFormContext()

  const _errorMessage = getErrorMessage(name) || errorMessage
  return (
    <FormControl isRequired={isRequired} isInvalid={_errorMessage} w={w}>
      <CommonFormLabel
        label={label}
        labelIndexNumber={labelIndexNumber}
        helpTooltipText={helpTooltipText}
        isRequired={isRequired}
      />
      <Input
        type="number"
        {...register(name, { valueAsNumber: true })}
        {...inputProps}
        required={false}
      />
      {showErrorText && (
        <FormErrorMessage>
          <AttentionIcon />
          {_errorMessage}
        </FormErrorMessage>
      )}
      {helperText && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  )
}
